/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-12-23 13:19:18
 * @LastEditors  : 侯鹏许(houpengxu@qq.com)
 * @LastEditTime : 2020-01-08 12:54:59
 * @Description: file content
 */
import Vue from 'vue/dist/vue.js'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

/**
* 加载src根目录的组件
*/
const requireComponent = require.context(
  // 其组件目录的相对路径
  `@/components`,
  // 是否查询其子目录
  false,
  // 匹配基础组件文件名的正则表达式
  /ActBase[A-Z]\w+\.(vue|js)$/
)
requireComponent.keys().forEach(fileName => {
  // 获取组件配置
  const componentConfig = requireComponent(fileName)

  // 获取组件的 PascalCase 命名
  const componentName = upperFirst(
    camelCase(
      // 获取和目录深度无关的文件名
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  )

  // 全局注册组件
  Vue.component(
    componentName,
    // 如果这个组件选项是通过 `export default` 导出的，
    // 那么就会优先使用 `.default`，
    // 否则回退到使用模块的根。
    componentConfig.default || componentConfig
  )
})
